import * as yup from 'yup';

export const verificationCodeSize = 6;

export const verificationCode = yup.string().length(verificationCodeSize);
